import { useQuery } from "@tanstack/react-query";
import getProjects from "./projects/get";
import getProjectsByUser from "./projects/byUser";

export const useProjects = () => {
  return useQuery({
    queryKey: ["campaigns"],
    queryFn: getProjects,
    initialData: [],
  });
};

export const useProjectsByUser = () => {
  return useQuery({
    queryKey: ["campaignsByUser"],
    queryFn: getProjectsByUser,
    initialData: [],
  });
};
